import store from "../index";

const state = () => ({
  isProfileComplited: false,
  isLinkValid: false,
  selectedSchemeResults: [],
  selectedFiltersPairs: {},
  selectedStatuses: [],
  savedSchemesSearch: {},
  showSave: false,
  showSaveScheme: false,
  showSaveSchemePortals: false,
  showAddNew: false,
  activeUserManagementTab: "",
  showConfirmation: false,
  clearAddUserFields: false,
  user: {
    id: null,
    username: "",
    email: "",
    person: {
      firstName: "",
      lastName: "",
      customer: "",
      portalOrganisation: "",
      isAccountManager: false,
      salutation: "",
    },
    themeType: "",
    searchInterest: "",
    isInformedAboutNews: "",
  },
  usersProfession: "",
  isProfessionSelected: false,
  customer: {
    id: null,
    name: "",
    emailSuffix: "",
    numberOfLicences: 0,
    persons: [],
    customerPortalSignatureName: "",
    startDate: "",
    isFomoAccess: false,
  },
  folderSchemeItem: {
    id: null,
    schemeId: null,
    folderId: null,
    individualSchemeStatus: "",
  },
  individualSchemeStatuses: [],
  isProfileSearch: false,
  savedAudienceTags: "",
  savedPurposesTags: "",
  //This is just hidden for now, don't remove it:
  // savedIndustriesTags: '',
  savedSchemeTypesTags: "",
  savedProjectTypesTags: "",
  savedOrganisationsExclude: "",
  savedOrganisationsInclude: "",
  savedLocationsTags: "",
  selectedFavoriteLocations: [],
  selectedFavoritePurposes: [],
  selectedFavoriteAudience: [],
  favoriteAudienceTagsString: "",
  //This is just hidden for now, don't remove it:
  //favoriteIndustriesTagsString: '',
  favoritePurposesTagsString: "",
  favoriteAudiencesIdsArray: [],
  //This is just hidden for now, don't remove it:
  //favoriteIndustriesIdsArray: [],
  favoritePurposesIdsArray: [],
  newsletterFrequencyType: "",
  schemeChangesInNewsletterStatus: false,
  openDetailsInNewTab: false,
  hideHiddenItemsDialog: false,
  showSavedInfoDialog: false,
  showSavedSearchInfoDialog: false,
  showHiddenInfoDialog: false,
  showProfileNotSetWarning: false,
  showAppliedFiltersInfo: false,
  folders: [{}],
  folderSchemes: [{}],
  folderSearches: [{}],
  filteredArray: [{}],
  filteredArraySearches: [{}],
  hiddenSchemesFilter: [{}],
  firstFolderId: 0,
  firstFolderName: "",
  hiddenSchemesList: [{}],
  hasModalError: false,
  modalErrorMessage: "",
  isApplyingFilters: false,
  receiveAlertForSavedSearch: false,
  savedSearchFolderItemId: 0,
  receiveAlertForSavedItems: false,
  savedSchemesFolderItemsIds: [],
  showAddUser: false,
  salutationsList: [],
  newsletterFrequencyTypes: [],
  showEditUserDrawer: false,
  selectedUserForEdit: {
    id: 0,
    email: "",
    firstName: "",
    lastName: "",
    department: "",
    isAccountManager: false,
    salutation: null,
    sasStartDate: null,
    sasEndDate: null,
    startDate: null,
    endDate: null,
    selectedContentRolesIds: [],
    selectedSasRolesIds: [],
    hasSasTaskEmails: false,
  },
  usersListDefaultEnv: [],
  hasComeFromNewsletter: false,
  newsletterParams: [],
  newsLetterId: 0,
  showRenameFolderDialog: false,
  pickedFolderName: "",
  isTourActive: false,
  // isSelectedThemeContrast: localStorage.getItem('themeContrast'),
  hasBeenRedirectedToProfile: false,
  hasSetProfileAfterLogin: false,
  showLeavingProfileSetupWarning: false,
  hasConfirmedLeave: false,
  toPath: "",
  toPathTab: "",
  isSelectedThemeContrast: false,
  isClickedSavedItems: false,
  isClickedUserManagement: false,
  isClickedNewsletter: false,
  isClickedMenuItemUsers: false,
  isClickedMenuItemCustomersBasic: false,
  isClickedMenuItemUserStats: false,
  isClickedMenuItemSchemes: false,
  isClickedMenuItemSearches: false,
  isClickedMenuItemAudiences: false,
  isClickedMenuItemPurposes: false,
  isClickedMenuItemLocations: false,
  // TODO : check for authUser
  customerLanguageCodeForUser: "",
  showReactivateSoftDeletedUserModal: false,
  refreshUsersGrid: false,
  contentRoles: [],
  sasRoles: [],
  filterChooserVisible: false,
  firstCategorization: {},
  secondCategorization: {}
});

const actions = {};

const getters = {};

const mutations = {
  updateShowReactivateSoftDeletedUserModal(state, val) {
    state.showReactivateSoftDeletedUserModal = val;
  },
  updateCustomerLanguageCodeForUser(state, val) {
    state.customerLanguageCodeForUser = val;
  },
  setIsLinkValid(state, val) {
    state.isLinkValid = val;
  },
  updateIsClickedUserManagement(state, val) {
    state.isClickedUserManagement = val;
  },
  updateIsClickedNewsletter(state, val) {
    state.isClickedNewsletter = val;
  },
  updateIsClickedSavedItems(state, val) {
    state.isClickedSavedItems = val;
  },
  updateIsClickedMenuItemSearches(state, val) {
    state.isClickedMenuItemSearches = val;
  },
  updateIsClickedMenuItemSchemes(state, val) {
    state.isClickedMenuItemSchemes = val;
  },
  updateIsClickedMenuItemAudiences(state, val) {
    state.isClickedMenuItemAudiences = val;
  },
  updateIsClickedMenuItemPurposes(state, val) {
    state.isClickedMenuItemPurposes = val;
  },
  updateIsClickedMenuItemLocations(state, val) {
    state.isClickedMenuItemLocations = val;
  },
  setToPathTab(state, val) {
    state.toPathTab = val;
  },
  setHasConfirmedLeave(state, val) {
    state.hasConfirmedLeave = val;
  },
  setToPath(state, val) {
    state.toPath = val;
  },
  updateHasBeenRedirectedToProfile(state, val) {
    state.hasBeenRedirectedToProfile = val;
  },
  updateShowLeavingProfileModal(state, val) {
    state.showLeavingProfileSetupWarning = val;
  },
  updateHasSetProfile(state) {
    state.hasSetProfileAfterLogin = true;
  },
  setIsSelectedThemeContrast(state, val) {
    state.isSelectedThemeContrast = val;
    localStorage.setItem("themeContrast", val);
  },
  updateIsTourActive(state, val) {
    state.isTourActive = val;
  },
  updatePortalOrganisation(state, val) {
    state.user.person.portalOrganisation = val;
  },
  updateIsProfileComplited(state, val) {
    state.isProfileComplited = val;
  },
  setHasComeFromNewsletter(state, val) {
    state.hasComeFromNewsletter = val;
  },
  updateActiveUserManagementTab(state, val) {
    state.activeUserManagementTab = val;
  },
  updateIsClickedMenuItemUsers(state, val) {
    state.isClickedMenuItemUsers = val;
  },
  updateIsClickedMenuItemCustomersBasic(state, val) {
    state.isClickedMenuItemCustomersBasic = val;
  },

  updateIsClickedMenuItemUserStats(state, val) {
    state.isClickedMenuItemUserStats = val;
  },
  updateUsersListDefaultEnv(state, users) {
    state.usersListDefaultEnv = users;
  },

  updateClearAddUserFields(state, val) {
    state.clearAddUserFields = val;
  },
  updateThemeType(state, val) {
    state.user.themeType = val;
  },
  updateSearchInterest(state, val) {
    state.user.searchInterest = val;
  },
  updateProfessionType(state, val) {
    state.usersProfession = val;
  },
  updateIsProfessionSelected(state, val) {
    state.isProfessionSelected = val;
  },
  updateIsInformedAboutNews(state, val) {
    state.user.isInformedAboutNews = val;
  },
  setNewsletterParams(state, val) {
    state.newsletterParams = val;
    state.newsLetterId = parseInt(val.newsId);
  },
  setIsApplyingFilters(state, val) {
    state.isApplyingFilters = val;
  },
  setReceiveAlertForSavedSearch(state, val) {
    state.receiveAlertForSavedSearch = val;
  },
  setReceiveAlertForSavedItems(state, val) {
    state.receiveAlertForSavedItems = val;
  },
  updateSelectedSchemeResults(state, val) {
    const index = state.selectedSchemeResults.indexOf(val);
    if (index > -1) {
      state.selectedSchemeResults.splice(index, 1);
    } else {
      state.selectedSchemeResults.push(val);
    }
  },
  enableSave(state) {
    state.showSave = true;
  },
  enableSaveScheme(state) {
    state.showSaveScheme = true;
  },
  enableSavePortalsScheme(state) {
    state.showSaveSchemePortals = true;
  },
  enableAddNew(state) {
    state.showAddNew = true;
  },
  enableConfirmation(state) {
    state.showConfirmation = true;
  },
  enableShowSavedInfoDialog(state, savedSchemesFolderItemsIds) {
    state.showSavedInfoDialog = true;

    if (state.savedSchemesFolderItemsIds.length > 0)
      state.savedSchemesFolderItemsIds = [];

    for (let i = 0; i < savedSchemesFolderItemsIds.length; i++)
      state.savedSchemesFolderItemsIds.push(savedSchemesFolderItemsIds[i]);
  },
  enableShowSavedSearchInfoDialog(state, savedSearchFolderItemId) {
    state.showSavedSearchInfoDialog = true;
    state.savedSearchFolderItemId = savedSearchFolderItemId;
  },
  enableShowProfileNotSetWarning(state) {
    state.showProfileNotSetWarning = true;
  },
  enableShowHiddenInfoDialog(state) {
    if (state.hideHiddenItemsDialog == false) state.showHiddenInfoDialog = true;
  },
  enableShowAppliedFiltersInfo(state) {
    state.showAppliedFiltersInfo = true;
  },
  disableConfirmation(state) {
    state.showConfirmation = false;
  },
  disableShowSavedInfoDialog(state) {
    state.showSavedInfoDialog = false;
    state.receiveAlertForSavedItems = false;
    state.savedSchemesFolderItemsIds = [];
  },
  disableShowSavedSearchInfoDialog(state) {
    state.showSavedSearchInfoDialog = false;
    state.receiveAlertForSavedSearch = false;
    state.savedSearchFolderItemId = 0;
  },
  disableShowHiddenInfoDialog(state) {
    state.showHiddenInfoDialog = false;
  },
  disableShowProfileNotSetWarning(state) {
    state.showProfileNotSetWarning = false;
  },
  disableShowAppliedFiltersInfo(state) {
    state.showAppliedFiltersInfo = false;
  },
  disableSave(state) {
    state.showSave = false;
  },
  disableSaveScheme(state) {
    state.showSaveScheme = false;
  },
  disableSavePortalsScheme(state) {
    state.showSaveSchemePortals = false;
  },
  disableAddNew(state) {
    state.showAddNew = false;
  },
  setIsProfileSearch(state, val) {
    state.isProfileSearch = val;
  },
  setIndividualSchemeStatus(state, val) {
    state.individualSchemeStatuses = val;
  },

  updateAudiencesPairs(state, val) {
    state.selectedFiltersPairs.audiences = val;
  },
  updateIndustriesNewPairs(state, val) {
    state.selectedFiltersPairs.industriesNew = val;
  },
  //This is just hidden for now, don't remove it:
  // updateIndustriesPairs(state, val) {
  //   state.selectedFiltersPairs.industries = val;
  // },

  updatePurposesPairs(state, val) {
    state.selectedFiltersPairs.purposes = val;
  },

  updateSchemeTypesPairs(state, val) {
    state.selectedFiltersPairs.schemeTypes = val;
  },

  updateProjectTypesPairs(state, val) {
    state.selectedFiltersPairs.projectTypes = val;
  },

  updateFavoriteAudiencesIdsArray(state, val) {
    if (state.favoriteAudiencesIdsArray.length > 0)
      state.favoriteAudiencesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoriteAudiencesIdsArray.push(val[i]);

    state.favoriteAudienceTagsString = String(state.favoriteAudiencesIdsArray);
  },
  //This is just hidden for now, don't remove it:
  /*
  updateFavoriteIndustriesIdsArray(state, val) {
    if (state.favoriteIndustriesIdsArray.length > 0)
      state.favoriteIndustriesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoriteIndustriesIdsArray.push(val[i]);
  },
  */
  updateFavoritePurposesIdsArray(state, val) {
    if (state.favoritePurposesIdsArray.length > 0)
      state.favoritePurposesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoritePurposesIdsArray.push(val[i]);

    state.favoritePurposesTagsString = String(state.favoritePurposesIdsArray);
  },

  updateSelectedFavoriteLocations(state, val) {
    state.selectedFavoriteLocations = val;
  },

  updateSelectedFavoritePurposes(state, val) {
    state.selectedFavoritePurposes = val;
  },

  updateSelectedFavoriteAudience(state, val) {
    state.selectedFavoriteAudience = val;
  },

  updateNewsletterFrequencyType(state, val) {
    state.newsletterFrequencyType = val;
  },

  updateSchemeChangesInNewsletterStatus(state, val) {
    state.schemeChangesInNewsletterStatus = val;
  },

  updateHideHiddenItemsDialog(state, val) {
    state.hideHiddenItemsDialog = val;
  },

  updateOpenDetailsInNewTab(state, val) {
    state.openDetailsInNewTab = val;
  },

  saveSchemesSearch(state) {
    state.savedSchemesSearch = {
      audienceTags:
        store.state.advancedSearch.selectedAudiences != ""
          ? store.state.advancedSearch.selectedAudiences
          : sessionStorage.getItem("selectedAudiences"),
      purposesTags:
        store.state.advancedSearch.selectedPurposes != ""
          ? store.state.advancedSearch.selectedPurposes
          : sessionStorage.getItem("selectedPurposes"),
      //This is just hidden for now, don't remove it:
      //industriesTags: store.state.advancedSearch.selectedIndustries,
      schemeTypesTags:
        store.state.advancedSearch.selectedSchemeTypes != ""
          ? store.state.advancedSearch.selectedSchemeTypes
          : sessionStorage.getItem("selectedSchemeTypes"),
      projectTypesTags: store.state.advancedSearch.selectedProjectTypes,
      statuses: JSON.parse(sessionStorage.getItem("schemeStatusGroup")).join(),
      organisationsInclude:
        store.state.advancedSearch.organisationsIncludeString != ""
          ? store.state.advancedSearch.organisationsIncludeString
          : sessionStorage.getItem("organisationsIncludeString"),
      organisationsExclude:
        store.state.advancedSearch.organisationsExcludeString != ""
          ? store.state.advancedSearch.organisationsExcludeString
          : sessionStorage.getItem("organisationsExcludeString"),
      startDate:
        store.state.advancedSearch.startDate != null &&
        store.state.advancedSearch.startDate != ""
          ? store.state.advancedSearch.startDate
          : JSON.parse(sessionStorage.getItem("startDate")),
      endDate:
        store.state.advancedSearch.endDate != null &&
        store.state.advancedSearch.endDate != ""
          ? store.state.advancedSearch.endDate
          : JSON.parse(sessionStorage.getItem("endDate")),
      minBudget:
        store.state.advancedSearch.minBudget != null
          ? store.state.advancedSearch.minBudget
          : Number(sessionStorage.getItem("minBudget")),
      maxBudget:
        store.state.advancedSearch.maxBudget != null
          ? store.state.advancedSearch.maxBudget
          : Number(sessionStorage.getItem("maxBudget")),
      locationsTags:
        store.state.advancedSearch.selectedLocations != ""
          ? store.state.advancedSearch.selectedLocations
          : sessionStorage.getItem("selectedLocations"),
      smeTypes: store.state.advancedFilters.smeString,
      scopesString: store.state.advancedFilters.selectedScopes.join(','),
      termsString: store.state.advancedFilters.termsString,
      searchText:
        store.state.advancedSearch.searchText != ""
          ? store.state.advancedSearch.searchText
          : sessionStorage.getItem("searchText"),
    };
  },

  fillUserObject(state, val) {
    (state.user.id = val.id), (state.user.username = val.username);
    state.user.email = val.email;
    state.user.person.firstName = val.person.firstName;
    state.user.person.lastName = val.person.lastName;
    state.user.person.customer = val.person.customer;
    state.user.person.salutation = val.salutation;
    state.user.person.portalOrganisation = val.person.portalOrganisation;
    //  state.user.themeType = val.person.personProfile
  },

  fillCustomerObject(state, val) {
    state.customer.id = val.id;
    state.customer.name = val.name;
    state.customer.emailSuffix = val.emailSuffix;
    state.customer.numberOfLicences = val.numberOfLicences;
    //can be removed?
    state.customer.customerPortalSignatureName =
      val.customerPortalSignatureName;
    //can be removed?
    state.customer.startDate = val.startDate;
    //can be removed
    state.customer.isFomoAccess = val.isFomoAccess;
  },

  fillFiltersWithSavedValues(state, val) {
    state.savedAudienceTags = val.audienceTags;
    var savedAudienceTagsArray = val.audienceTags
      ? val.audienceTags.split(",")
      : [];
    store.commit(
      "advancedSearch/updateSelectedAudiences",
      savedAudienceTagsArray
    );

    //This is just hidden for now, don't remove it:
    /*
    state.savedIndustriesTags = val.industriesTags;
    var savedIndustriesTagsArray = val.industriesTags.split(',');
    store.commit(
      'advancedSearch/updateSelectedIndustries',
      savedIndustriesTagsArray
    );
    */
    state.savedPurposesTags = val.purposesTags;
    var savedPurposesTagsArray = val.purposesTags
      ? val.purposesTags.split(",")
      : [];
    store.commit(
      "advancedSearch/updateSelectedPurposes",
      savedPurposesTagsArray
    );

    state.savedSchemeTypesTags = val.schemeTypesTags;
    var savedSchemeTypesTagsArray = val.schemeTypesTags
      ? val.schemeTypesTags.split(",")
      : [];
    store.commit(
      "advancedSearch/updateSelectedSchemeTypes",
      savedSchemeTypesTagsArray
    );

    state.savedProjectTypesTags =
      val.projectTypesTags === null ? "" : val.projectTypesTags;
    var savedProjectTypesTagsArray =
      val.projectTypesTags == null ? [] : val.projectTypesTags.split(",");
    store.commit(
      "advancedSearch/updateSelectedProjectTypes",
      savedProjectTypesTagsArray
    );

    state.savedOrganisationsInclude = val.organisations;
    state.savedOrganisationsExclude = val.notOrganisations;
    state.savedLocationsTags = val.locationsTags;

    if (
      state.savedOrganisationsInclude != null &&
      state.savedOrganisationsInclude.length > 0
    ) {
      var includeIds = new Array();
      includeIds = state.savedOrganisationsInclude.split(",");
      var includeOrgsArray = new Array();

      let allOrganisations =
        store.state.organisations.organisationsWithBasicInfo;

      for (let i = 0; i < allOrganisations.length; i++) {
        if (includeIds.includes(allOrganisations[i].id.toString()))
          includeOrgsArray.push(allOrganisations[i]);
      }
      store.commit(
        "advancedSearch/updateOrganisationsInclude",
        includeOrgsArray
      );
    } else {
      store.commit("advancedSearch/updateOrganisationsInclude", []);
    }

    if (
      state.savedOrganisationsExclude != null &&
      state.savedOrganisationsExclude.length > 0
    ) {
      var excludeIds = new Array();
      excludeIds = state.savedOrganisationsExclude.split(",");
      var excludeOrgsArray = new Array();

      let allOrganisations =
        store.state.organisations.organisationsWithBasicInfo;

      for (let i = 0; i < allOrganisations.length; i++) {
        if (excludeIds.includes(allOrganisations[i].id.toString()))
          excludeOrgsArray.push(allOrganisations[i]);
      }
      store.commit(
        "advancedSearch/updateOrganisationsExclude",
        excludeOrgsArray
      );
    } else {
      store.commit("advancedSearch/updateOrganisationsExclude", []);
    }

    if (
      state.savedLocationsTags != null &&
      state.savedLocationsTags.length > 0
    ) {
      var locationsIds = new Array();
      locationsIds = state.savedLocationsTags.split(",");
      var locationsArray = new Array();

      // Needs to be improved asap
      let allLocations = store.state.advancedSearch.locationsOptions;

      for (let i = 0; i < allLocations.length; i++) {
        if (locationsIds.includes(allLocations[i].id.toString())) {
          locationsArray.push(allLocations[i]);
        }
      }
      store.commit("advancedSearch/updateSelectedLocations", locationsArray);
    } else {
      store.commit("advancedSearch/updateSelectedLocations", []);
    }
  },
  fillFolderSchemeItem(state, val) {
    state.folderSchemeItem.id = val.id;
    state.folderSchemeItem.schemeId = val.schemeId;
    state.folderSchemeItem.folderId = val.folderId;
    state.folderSchemeItem.individualSchemeStatus = val.individualSchemeStatus;
  },

  updateUsername(state, val) {
    state.user.username = val;
  },
  updateEmail(state, val) {
    state.user.email = val;
  },
  updateFirstName(state, val) {
    state.user.person.firstName = val;
  },
  updateSalutation(state, val) {
    state.user.person.salutation = val;
  },
  updateFilteredArray(state, val) {
    state.filteredArray = val;
  },

  updateFilteredArraySearches(state, val) {
    state.filteredArraySearches = val;
  },

  updateLastName(state, val) {
    state.user.person.lastName = val;
  },
  updateCustomerName(state, val) {
    state.customer.name = val;
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  fillFolderItems(state, val) {
    if (state.folderSchemes.length > 0) {
      state.folderSchemes = [];
      state.filteredArray = [];
    }
    if (state.folderSearches.length > 0) {
      state.folderSearches = [];
      state.filteredArraySearches = [];
    }

    if (val.folderItems.length > 0) {
      var schemesItems = val.folderItems.filter(
        (item) => item.schemeId != null && item.schemeId != 0
      );
      var savedSearchesItems = val.folderItems.filter(
        (item) => item.searchId != null && item.searchId != 0
      );

      if (schemesItems.length > 0) {
        for (let i = 0; i < schemesItems.length; i++) {
          schemesItems.selectedSchemeForSharing = false;
          state.folderSchemes.push(schemesItems[i]);
          state.filteredArray.push(schemesItems[i]);
        }
      }
      if (savedSearchesItems.length > 0) {
        for (let j = 0; j < savedSearchesItems.length; j++) {
          state.folderSearches.push(savedSearchesItems[j]);
          state.filteredArraySearches.push(savedSearchesItems[j]);
        }
      }
    }
  },
  fillFolders(state, val) {
    if (state.folders.length > 0) state.folders = [];
    if (val.length > 0) {
      state.firstFolderId = val[0].id;
      state.firstFolderName = val[0].name;
    }
    for (let i = 0; i < val.length; i++) state.folders.push(val[i]);
  },
  updateFirstFolderId(state, val) {
    state.firstFolderId = val;
  },
  fillHiddenSchemesList(state, val) {
    if (state.hiddenSchemesList.length > 0) {
      state.hiddenSchemesList = [];
      state.hiddenSchemesFilter = [];
    }
    for (let i = 0; i < val.length; i++) {
      state.hiddenSchemesList.push(val[i]);
      state.hiddenSchemesFilter.push(val[i]);
    }
  },
  enableAddUser(state) {
    state.showAddUser = true;
  },
  disableAddUser(state) {
    state.showAddUser = false;
  },
  updateSalutationsList(state, value) {
    state.salutationsList = value;
  },
  updateNewsletterFrequencyTypes(state, value) {
    state.newsletterFrequencyTypes = value.filter(
      (item) => item.description.toLowerCase() !== "undefined"
    );
  },
  enableEditUser(state, userObject) {
    state.selectedUserForEdit.id = userObject.id;
    state.selectedUserForEdit.email = userObject.email;
    state.selectedUserForEdit.firstName = userObject.firstName;
    state.selectedUserForEdit.lastName = userObject.lastName;
    state.selectedUserForEdit.department = userObject.department;
    state.selectedUserForEdit.salutation = userObject.salutation;
    state.selectedUserForEdit.isAccountManager = userObject.isAccountManager;
    state.selectedUserForEdit.startDate = userObject.startDate;
    state.selectedUserForEdit.endDate = userObject.endDate;
    state.selectedUserForEdit.sasStartDate = userObject.sasStartDate;
    state.selectedUserForEdit.sasEndDate = userObject.sasEndDate;
    state.selectedUserForEdit.selectedContentRolesIds =
      userObject.contentRoles.map((r) => r.id);
    state.selectedUserForEdit.selectedSasRolesIds = userObject.sasRoles.map(
      (r) => r.id
    );
    state.selectedUserForEdit.hasSasTaskEmails =
      userObject.receivingSasTaskEmails;

    state.showEditUserDrawer = true;
  },
  disableEditUser(state) {
    state.showEditUserDrawer = false;
  },
  updateHiddenSchemesListFilter(state, val) {
    state.hiddenSchemesFilter = val;
  },
  updateSelectedUserEmail(state, val) {
    state.selectedUserForEdit.email = val;
  },
  updateSelectedUserFirstName(state, val) {
    state.selectedUserForEdit.firstName = val;
  },
  updateSelectedUserLastName(state, val) {
    state.selectedUserForEdit.lastName = val;
  },
  updateSelectedUserIsAccountManager(state, val) {
    state.selectedUserForEdit.isAccountManager = val;
  },
  updateSelectedUserDepartment(state, val) {
    state.selectedUserForEdit.department = val;
  },
  updateSelectedUserStartDate(state, val) {
    state.selectedUserForEdit.startDate = val;
  },
  updateSelectedUserEndDate(state, val) {
    state.selectedUserForEdit.endDate = val;
  },
  updateSelectedUserSasStartDate(state, val) {
    state.selectedUserForEdit.sasStartDate = val;
  },
  updateSelectedUserSasEndDate(state, val) {
    state.selectedUserForEdit.sasEndDate = val;
  },
  updateSelectedUserContentRolesIds(state, val) {
    state.selectedUserForEdit.selectedContentRolesIds = val;
  },
  updateSelectedUserSasRolesIds(state, val) {
    console.log(val);
    state.selectedUserForEdit.selectedSasRolesIds = val;
  },
  updateSelectedUserHasSasTaskEmails(state, val) {
    state.selectedUserForEdit.hasSasTaskEmails = val;
  },

  updatePickedFolderName(state, val) {
    state.pickedFolderName = val;
  },
  enableRenameFolderDialog(state, pickedFolderName) {
    state.pickedFolderName = pickedFolderName;
    state.showRenameFolderDialog = true;
  },
  disableRenameFolderDialog(state) {
    state.showRenameFolderDialog = false;
  },
  triggerUsersGridRefresh(state) {
    state.refreshUsersGrid = !state.refreshUsersGrid;
  },
  setContentRoles(state, val) {
    state.contentRoles = val;
  },
  setSasRoles(state, val) {
    state.sasRoles = val;
  },
  enableFilterChooser(state) {
    state.filterChooserVisible = true;
  },
  disableFilterChooser(state) {
    state.filterChooserVisible = false;
  },
  updateCategorizations(state, val) {
    if (val && val.length > 0) {
      state.firstCategorization.parentName = val[0].name;
      state.firstCategorization.parentId = val[0].id;
      state.firstCategorization.categories = val[0].categories;

      if (val[1]) {
        state.secondCategorization.parentName = val[1].name;
        state.secondCategorization.parentId = val[1].id;
        state.secondCategorization.categories = val[1].categories;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
